import { createAction } from '@reduxjs/toolkit';

import { Car } from 'models/car';

export const updateVehicleFromPusher = createAction<Car>('vehicles/updateVehicleFromPusher');
